import { createStore as reduxCreateStore } from 'redux';
import reducers from './reducers';

const createStore = () => reduxCreateStore(reducers, 
     //(window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
    );
export default createStore;
